import { ExerciseType } from './types';

export const APP_NAME = "Level Up";
export const APP_SUBHEADING = "powered by VON v1.0";

export const EXERCISE_CONFIG = {
  [ExerciseType.SQUAT]: {
    name: 'Squats',
    description: 'Thighs parallel or lower. Full extension at top.',
    thresholdDown: 100, // Strict: ~Parallel
    thresholdUp: 165,   // Strict: Full Lockout
    primaryJoints: [23, 25, 27], // Hip, Knee, Ankle (Left)
  },
  [ExerciseType.PUSHUP]: {
    name: 'Push-ups',
    description: 'Chest to floor (90° elbows). Full lockout.',
    thresholdDown: 90,  // Strict: 90 degrees at elbow
    thresholdUp: 165,   // Strict: Full extension
    primaryJoints: [11, 13, 15], // Shoulder, Elbow, Wrist (Left)
  },
  [ExerciseType.JUMPING_JACK]: {
    name: 'Jumping Jacks',
    description: 'Hands touch overhead. Feet wide.',
    thresholdDown: 160, // Arms fully overhead
    thresholdUp: 20,    // Hands returned to sides
    primaryJoints: [11, 23], // Shoulder, Hip
  },
  [ExerciseType.SITUP]: {
    name: 'Sit-ups',
    description: 'Shoulders touch floor. Chest to knees.',
    thresholdDown: 50,  // Strict: Full crunch
    thresholdUp: 130,   // Strict: Shoulders back on ground
    primaryJoints: [11, 23, 25], // Shoulder, Hip, Knee
  }
};

export const COLORS = {
  primary: '#FFFFFF',
  secondary: '#71717A',
  alert: '#EF4444',
};